import axios from 'axios';

const API_BASE_URL = import.meta.env.VITE_API_URL || '/api';

// Create axios instance with auth interceptor
const api = axios.create({
  baseURL: API_BASE_URL,
});

// Add auth token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('access_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Google Sheets API Service
export const googleSheetsService = {
  // Configurations
  async createConfig(configData) {
    const response = await api.post('/google-sheets/configs', configData);
    return response.data;
  },

  async getConfigs(projectId = null) {
    const params = projectId ? { project_id: projectId } : {};
    const response = await api.get('/google-sheets/configs', { params });
    return response.data;
  },

  async getConfig(configId) {
    const response = await api.get(`/google-sheets/configs/${configId}`);
    return response.data;
  },

  async updateConfig(configId, configData) {
    const response = await api.put(`/google-sheets/configs/${configId}`, configData);
    return response.data;
  },

  async deleteConfig(configId) {
    const response = await api.delete(`/google-sheets/configs/${configId}`);
    return response.data;
  },

  // Credentials
  async uploadCredentials(configId, file) {
    const formData = new FormData();
    formData.append('file', file);
    
    const response = await api.post(`/google-sheets/upload-credentials/${configId}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  // Connection testing
  async testConnection(configId) {
    const response = await api.post(`/google-sheets/test-connection/${configId}`);
    return response.data;
  },

  // Syncing
  async syncFromSheets(configId, syncType = 'manual') {
    const response = await api.post('/google-sheets/sync', {
      config_id: configId,
      sync_type: syncType
    });
    return response.data;
  },

  // Sync logs
  async getSyncLogs(configId, limit = 20) {
    const response = await api.get(`/google-sheets/sync-logs/${configId}`, {
      params: { limit }
    });
    return response.data;
  },

  // Available sheets
  async getAvailableSheets(credentialsFile) {
    const response = await api.get('/google-sheets/available-sheets', {
      params: { credentials_file: credentialsFile }
    });
    return response.data;
  },

  // AWB Data Extraction (OAuth-based)
  async extractAwbData(sheetId, configData) {
    const response = await api.post(`/google-oauth/sheets/${sheetId}/extract-awb-data`, configData);
    return response.data;
  },

  // OTDR Data Extraction (OAuth-based)
  async extractOTDRData(sheetId, configData) {
    const response = await api.post(`/google-oauth/sheets/${sheetId}/extract-otdr-data`, configData);
    return response.data;
  },

  // Save OAuth-based configuration
  async saveOAuthConfiguration(configData) {
    const response = await api.post('/google-sheets/oauth-configurations', configData);
    return response.data;
  }
};

export default googleSheetsService;